import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  private _supportsWebp;

  private listeners:Array<Function> = [];

  constructor() {
    this.check_webp_feature('lossless', (feature, value) => {
      this._supportsWebp = value;
      this.notifyLoadListeners();
    });
  }

  addLoadListener = (listener:Function) => {
    if(typeof this._supportsWebp === 'undefined') {
      this.listeners.push(listener);
    }
    else {
      listener();
    }
  }

  supportsWebp = () => {
    return this._supportsWebp;
  }

  private notifyLoadListeners = () => {
    for(let listener of this.listeners) {
      listener();
    }
    this.listeners = [];
  }



  //https://developers.google.com/speed/webp/faq#how_can_i_detect_browser_support_for_webp
  private check_webp_feature = (feature, callback) => {
    var kTestImages = {
      lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
      lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
      alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
      animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    var img = new Image();
    img.onload = function () {
      var result = (img.width > 0) && (img.height > 0);
      callback(feature, result);
    };
    img.onerror = function () {
      callback(feature, false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
  }
}
